import { render, staticRenderFns } from "./font_awesome.vue?vue&type=template&id=68ef8f00"
import script from "./font_awesome.vue?vue&type=script&lang=js"
export * from "./font_awesome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports